export default [
  {
    path: '/partners',
    name: 'dashboard-partners',
    component: () => import('@/views/dashboard/partners/Partners.vue'),
  },
  {
    path: '/partners/:id/edit',
    name: 'dashboard-partner-edit',
    component: () => import('@/views/dashboard/partners/Edit.vue'),
    active: true,
  },
  {
    path: '/partners/create',
    name: 'dashboard-partners-create',
    component: () => import('@/views/dashboard/partners/Create.vue'),
    active: true,
  },
  {
    path: '/partners/:id',
    name: 'dashboard-partner',
    component: () => import('@/views/dashboard/partners/Partner.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats',
    name: 'dashboard-partner-stats',
    component: () => import('@/views/dashboard/partners/Stats.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/subscriptions',
    name: 'dashboard-partner-stats-subscriptions',
    component: () => import('@/views/dashboard/partners/stats/StatsSubscribed.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/phoenix',
    name: 'dashboard-partner-stats-phoenix',
    component: () => import('@/views/dashboard/partners/stats/StatsPhoenix.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/phoenix/partners',
    name: 'dashboard-partner-stats-phoenix-partners',
    component: () => import('@/views/dashboard/partners/stats/StatsPhoenixPartners.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/phoenix/partners/:partnerId',
    name: 'dashboard-partner-stats-phoenix-partners-details',
    component: () => import('@/views/dashboard/partners/stats/StatsPhoenixPartnersDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/phoenix/geo',
    name: 'dashboard-partner-stats-phoenix-geo',
    component: () => import('@/views/dashboard/partners/stats/StatsPhoenixGeo.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/phoenix/geo/:countryName',
    name: 'dashboard-partner-stats-phoenix-geo-details',
    component: () => import('@/views/dashboard/partners/stats/StatsPhoenixGeoDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/phoenix/device',
    name: 'dashboard-partner-stats-phoenix-device',
    component: () => import('@/views/dashboard/partners/stats/StatsPhoenixDevice.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/phoenix/device/:deviceName',
    name: 'dashboard-partner-stats-phoenix-device-details',
    component: () => import('@/views/dashboard/partners/stats/StatsPhoenixDeviceDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/dsp',
    name: 'dashboard-partner-stats-dsp',
    component: () => import('@/views/dashboard/partners/stats/StatsDsp.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/dsp/partners',
    name: 'dashboard-partner-stats-dsp-partners',
    component: () => import('@/views/dashboard/partners/stats/DspPartnersStats.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/dsp/partners/:dspId',
    name: 'dashboard-partner-stats-dsp-partners-details',
    component: () => import('@/views/dashboard/partners/stats/DspPartnersDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/geo',
    name: 'dashboard-partner-stats-geo',
    component: () => import('@/views/dashboard/partners/stats/GeoStats.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/geo/country/:countryId',
    name: 'dashboard-partner-stats-geo-country-details',
    component: () => import('@/views/dashboard/partners/stats/GeoDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/geo/city/:cityId',
    name: 'dashboard-partner-stats-geo-city-details',
    component: () => import('@/views/dashboard/partners/stats/GeoDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/device',
    name: 'dashboard-partner-stats-device',
    component: () => import('@/views/dashboard/partners/stats/DeviceOsStats.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/device/:deviceId',
    name: 'dashboard-partner-stats-device-details',
    component: () => import('@/views/dashboard/partners/stats/DeviceOsDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/stats/os/:osId',
    name: 'dashboard-partner-stats-os-details',
    component: () => import('@/views/dashboard/partners/stats/DeviceOsDetails.vue'),
    active: true,
  },
  {
    path: '/partners/:id/logs',
    name: 'dashboard-partner-logs',
    component: () => import('@/views/dashboard/partners/Logs.vue'),
    active: true,
  },
]
